import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import '../src/style/css/custom.css'
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import GlobalExportListener from "./ExportData/GlobalExportListener";
import GlobalMasterListener from "./core/AiActions/GlobalMasterListener";
import App from "./app";
// import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* <ConfigProvider> */}
      <Provider store={store}>
         <GlobalExportListener /> 
         <GlobalMasterListener /> 
        <BrowserRouter basename={base_path}>
           <App /> 
        </BrowserRouter>
      </Provider>
    {/* </ConfigProvider> */}
  </React.StrictMode>
);
